import { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { validationUtils } from 'basic-components';

import { PickersUtils } from 'primary/pickers/Utils';

import { When } from 'react-if';

import classNames from 'classnames';
import './JustError.scss';

const EMPTY_ARRAY = [];
const JustError = ({
  name,
  defaultValue = "",
  validators = EMPTY_ARRAY,
  required = false,
  ref
}) => { 
  const [initialized, setInitialized] = useState(false),
        [isValid, setValid] = useState(true),
        [errorMessage, setErrorMessage] = useState(undefined),
        [isOverflowed, setOverflowed] = useState(false),
        
        refErrorMessage = useRef(null),
        validate = useCallback(v => validationUtils.validateNoState(v, validators, name, required, setValid, setErrorMessage), [validators, name, required])

  useEffect(() => {
    if (initialized) {
      validate(typeof defaultValue === "string" ? defaultValue : JSON.stringify(defaultValue))
    }
  }, [defaultValue, name, validate, initialized])

  useEffect(() => {
    setInitialized(true)
  }, [initialized])

  useImperativeHandle(ref, () => ({ 
    validateForForm: () => validate(typeof defaultValue === "string" ? defaultValue : JSON.stringify(defaultValue)),
    isValid: () => isValid
  }))
  useEffect(() => {
    if(refErrorMessage.current && refErrorMessage.current.clientWidth < refErrorMessage.current.scrollWidth) {
      setOverflowed(true)
    } else {
      setOverflowed(false)
    }
  }, [isValid, errorMessage])

  return (
    <div 
        className={classNames("data-science__pipeline-creator__body__options__resolver__bottom-row__just-error", { "data-science__pipeline-creator__body__options__resolver__bottom-row__just-error--is-none": isValid })}
        data-testid="text-field-error-container"
    >
      <p ref={refErrorMessage}>
        {errorMessage}
      </p>
      <When condition={isOverflowed}>
        {() => PickersUtils.getErrorTooltip(errorMessage, "data-science__pipeline-creator__body__options__resolver__bottom-row__just-error__more")}
      </When>
    </div>
  )
}


JustError.propTypes = {
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  validators: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    validator: PropTypes.func.isRequired
  })),
}

JustError.displayName = 'JustError'

export default JustError;
